export default "__VITE_ASSET__DUcWnXmY__"